import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { timeout, retry } from "rxjs/operators";
import { Observable } from "rxjs";
import { AppConfig } from "../../../app/app-config.module";

import { ICompany, ICompanyDuplicate, ICompany_V2, SearchCompany } from "../../shared/models/company.model";
import { IPagination, IResponse } from "../../shared/models/response.model";
import { ICompanyType } from "../../shared/models/company-type.model";

@Injectable({
  providedIn: "root",
})
export class CompanyService {
  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {}

  getCompany(cpid: string): Observable<any> {
    return this.http
      .post<any>(`${this.config.apiEndpoint}/users/getcompany`, { cpid: cpid })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  searchCompany(
    pageNum: number,
    pageSize: number,
    companySearch: SearchCompany
  ): Observable<IResponse<IPagination<ICompany>>> {
    return this.http
      .post<IResponse<IPagination<ICompany>>>(`${this.config.apiEndpoint}/users/getlistcompany`, {
        pageNum: pageNum,
        pageSize: pageSize,
        ...companySearch,
      })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  getCompanyType(): Observable<IResponse<ICompanyType[]>> {
    return this.http
      .post<IResponse<ICompanyType[]>>(`${this.config.apiEndpoint}/users/getlistcompanytype`, {})
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  checkDuplicateCompanyName(name: string): Observable<IResponse<ICompanyDuplicate>> {
    return this.http
      .post<IResponse<ICompanyDuplicate>>(`${this.config.apiEndpoint}/users/checkduplicatecompanyname`, {
        name: name,
      })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  createCompany(company: ICompany): Observable<IResponse<ICompany>> {
    return this.http
      .post<any>(`${this.config.apiEndpoint}/users/createcompany`, company)
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  updateCompany(company: ICompany): Observable<IResponse<ICompany>> {
    return this.http
      .post<any>(`${this.config.apiEndpoint}/users/updatecompany`, company)
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  deleteCompany(cpid: string): Observable<any> {
    return this.http
      .post<any>(`${this.config.apiEndpoint}/users/deletecompany`, cpid)
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }
  updateStatus(data:any):Observable<IResponse<ICompany>>{
    return this.http.post<IResponse<ICompany>>(`${this.config.apiEndpoint}/users/updatecompanystatus`,data)
    .pipe(timeout(this.config.apiTimeout),retry(this.config.apiRetry));
  }

  getCompany_V2(cpid: string): Observable<any> {
    return this.http
      .post<any>(`${this.config.apiEndpoint}/users/v2/getcompany`, { cpid: cpid })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  createCompany_V2(data: any): Observable<any> {
    return this.http
      .post<any>(`${this.config.apiEndpoint}/users/v2/createcompany`, data)
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  updateCompany_V2(data: any): Observable<any> {
    return this.http
      .post<any>(`${this.config.apiEndpoint}/users/v2/updatecompany`, data)
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  getCompanyTypeByRegisterType(registerType: number): Observable<any> {
    return this.http
      .post<any>(`${this.config.apiEndpoint}/users/getlistcompanytypebyregistertype`, {
        registerType: registerType
      })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  searchCompany_V2(
    pageNum: number,
    pageSize: number,
    companySearch: SearchCompany
  ): Observable<IResponse<IPagination<ICompany_V2>>> {
    return this.http
      .post<IResponse<IPagination<ICompany_V2>>>(`${this.config.apiEndpoint}/users/v2/getlistcompany`, {
        pageNum: pageNum,
        pageSize: pageSize,
        ...companySearch,
      })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

}
